<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="' '+(overlay.name)"
        ref="geoitemEditLayer"
        @ready="onReady()"
    >
    </l-layer-group>
</template>

<script>
import {LLayerGroup} from "@vue-leaflet/vue-leaflet";
import {mapGetters, mapActions} from "vuex";
import {corridor as LCorridor} from "@/components/app/map/leaflet-corridor";

export default {
    name: "SectionMap_layer_geoitem_edit",
    mixins: [],
    inject: ['L', 'mapLeafletObject'],
    props: {
        modelValue: Object,
    },
    emits: ['update:modelValue'],
    components: {
        LLayerGroup,
    },
    data() {
        return {
            geoitemEditLayer: null,
            drawLayer: null,
            drawnItems: null,
            areaLabel: null,
            areaLayer: null,
            areaPolygon: null,

            drawControl: null,
            draw: null,
        }
    },
    computed: {
        ...mapGetters([
            "getGeoitemEdit",
        ]),
        isRouteName_geoitems_main(){
            return this.routeName === this.$consts.routerNames.geoitems.main
        },
        isMainParentRouteName_geoitems(){
            return this.mainParentRouteName === this.$consts.routerNames.geoitems.main
        },

        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
    },
    watch: {
        getGeoitemEdit: {
            handler: function (newGeo, oldGeo) {
                // if(this.$isDevelopment) console.log('getGeoitemEdit', (newGeo?{...newGeo}:newGeo), (oldGeo?{...oldGeo}:oldGeo))
                this.updateGeoitemEdit(newGeo, oldGeo)
                // if(this.$isDevelopment) console.log('getGeoitemEdit', (newGeo?{...newGeo}:newGeo), {...overlay})
            },
            deep: true
        },
    },
    methods: {
        ...mapActions([
            "setMapBoundsByGeozones",
            "patchGeoitemEdit",
        ]),
        getDataFromLayer(layer) {
            let data = null
            if (layer.getRadius) {
                data = {}
                data.radius = layer.getRadius();
                data.area = Math.pow(data.radius, 2) * Math.PI;
                data.points = [['' + layer.getLatLng().lat, '' + layer.getLatLng().lng, '0']];
            } else
            if (layer.polyline_geozone) {
                data = {}
                data.radius = layer.radius_polyline;
                data.area = this.L.GeometryUtil.geodesicArea(layer.polyline_geozone);
                data.points = this.getPointsFromLayer(layer.polyline_geozone);
                data.pointsPolyLine = this.getPointsFromLayer(layer);
            } else
            {
                let latLngs = layer.getLatLngs();
                if (latLngs[0] && Array.isArray(latLngs[0])) {
                    latLngs = latLngs[0];
                }
                data = {}
                data.area = this.L.GeometryUtil.geodesicArea(latLngs);
                data.points = this.getPointsFromLayer(layer);
            }
            return data
        },
        getPointsFromLayer(layer) {
            var latLngs = layer.getLatLngs(),
                points = [];
            if (latLngs[0]) {
                if (Array.isArray(latLngs[0])) {
                    latLngs = latLngs[0];
                }
            }
            latLngs.forEach(function (latLng) {
                points.push([latLng.lat, latLng.lng]);
            });
            return points;
        },

        createGeoiteme(geoitemLOptions) {
            let geoitem = null
            let options = {...geoitemLOptions}
            //fillColor???
            if (!options.fillOpacity) options.fillOpacity = 0.5
            if (options.type === 'circle') {
                if (options.points && options.points.length == 1 && options.radius) {
                    let center = options.points[0]
                    if(!center?.length && center?.length != 0) {
                        console.error('points null', options)
                    }
                    if (center?.length > 2) center = center.slice(0, 2);
                    geoitem = this.L.circle(center, options.radius, options);
                }
            } else
            if (options.type === 'polygon') {
                if (options.points && options.points.length > 1) {
                    geoitem = this.L.polygon(options.points, options);
                }
            } else
            if (options.type === 'corridor') {
                options.layerType = 'polyline'
                options.polyline_radius = options.radius;
                options.corridor = options.radius / 2;
                if (options.points && options.points.length > 1) {
                    geoitem = LCorridor(options.points, options);
                }
            }
            return geoitem
        },
        updateGeoitemEdit(newGeo, oldGeo) {
            if (
                newGeo && oldGeo && (
                    (newGeo.geoitemId  && +newGeo.geoitemId  === +oldGeo.geoitemId) ||
                    (newGeo.geopointId && +newGeo.geopointId === +oldGeo.geopointId) ||
                    (newGeo.geozoneId  && +newGeo.geozoneId  === +oldGeo.geozoneId)
                )
            ) {
                if (newGeo.color !== oldGeo.color) {
                    let color = (newGeo.color ? newGeo.color : '#00ff00')
                    if (this.drawLayer) {
                        this.drawLayer.setStyle({
                            color: color,
                            fillColor: color,
                            fillOpacity: 0.5
                        })
                    }
                    if (this.drawControl) {
                        this.drawControl.options.draw.polygon.drawError.color =
                        this.drawControl.options.draw.polygon.shapeOptions.color =
                        this.drawControl.options.draw.polyline.shapeOptions.color =
                        this.drawControl.options.draw.circle.shapeOptions.color =
                        color;
                    }
                }
                // if(this.$isDevelopment) console.log('skip geoitem')
                return;
            }

            if (oldGeo) {
                if (this.drawLayer) {//???
                    this.mapLeafletObject.removeLayer(this.drawLayer);
                }
                if (this.draw) {
                    this.draw.disable();
                }
            }

            if (!newGeo) {//close
                try { // [!] Mega hack 🤘
                    if (this.drawLayer) {//???
                        this.mapLeafletObject.removeLayer(this.drawLayer);
                    }
                    if (this.draw) {
                        this.draw.disable();
                    }
                    if (this.drawnItems) {
                        this.mapLeafletObject.removeLayer(this.drawnItems);
                    }
                    if (this.areaLayer) {
                        this.mapLeafletObject.removeLayer(this.areaLayer);
                    }
                    if (this.areaLabel) {
                        this.mapLeafletObject.removeLayer(this.areaLabel);
                    }
                    if (this.areaPolygon) {
                        this.areaPolygon.disable();
                        this.areaPolygon = null;
                    }
                } catch (error) {
                    console.error(error);
                }
                return;
            }

            // if(this.$isDevelopment) console.log('getGeoitemEdit', {...newGeo}, {...oldGeo}, this.geoitemEdit)
            if (!oldGeo) {
                this.drawnItems = new this.L.FeatureGroup();
                this.mapLeafletObject.addLayer(this.drawnItems);
                this.drawControl = new this.L.Control.Draw({
                    draw: {
                        position: 'topleft',
                        polygon: {
                            title: ('Draw polygon!'),
                            allowIntersection: false,
                            drawError: {
                                color: newGeo.color, //'#00ff00',
                                timeout: 1000
                            },
                            shapeOptions: {
                                color: newGeo.color, //'#00ff00'
                            },
                            showArea: true
                        },
                        polyline: {
                            shapeOptions: {
                                color: newGeo.color, //'#00ff00'
                            }
                        },
                        marker: false,
                        rectangle: false,
                        circle: {
                            shapeOptions: {
                                color: newGeo.color, //'#00ffff'
                            }
                        }
                    },
                    edit: {
                        featureGroup: this.drawnItems
                    }
                });
                //this.geoitemsLayer.addControl(this.drawControl);//???
            }
            {
                this.mapLeafletObject.on(this.L.Draw.Event.CREATED, (e) => {
                    // if(this.$isDevelopment) console.log(this.L.Draw.Event.CREATED, e);
                    var type = e.layerType,
                        layer = e.layer;
                    this.drawLayer = layer;
                    this.drawLayer.editing.enable();
                    this.drawnItems.addLayer(layer);

                    if (type == 'polyline') {
                        /*draw temp polygone for polyline*/
                        if (this.drawLayer._latlngs) {
                            this.drawLayer.layerType = 'polyline';
                            this.DrawPolylineOnMap(this.drawLayer._latlngs);
                        }
                    }
                    //onDrawCreatedTrigger = true;
                });

                this.mapLeafletObject.on(this.L.Draw.Event.DRAWVERTEX, (e) => {
                    if(this.$isDevelopment) console.log(this.L.Draw.Event.DRAWVERTEX, e);
                });
                this.mapLeafletObject.on(this.L.Draw.Event.EDITVERTEX, (e) => {
                    if(this.$isDevelopment) console.log(this.L.Draw.Event.EDITVERTEX, e);
                    if (this.drawLayer && this.drawLayer._latlngs && this.drawLayer.layerType == 'polyline') {
                        this.DrawPolylineOnMap(this.drawLayer._latlngs);
                    }
                });
                this.mapLeafletObject.on(this.L.Draw.Event.DRAWSTOP, (e) => {
                    if(this.$isDevelopment) console.log(this.L.Draw.Event.DRAWSTOP, e);
                    let data = {}
                    if (this.drawLayer) {
                        data = this.getDataFromLayer(this.drawLayer)
                    }
                    // if(this.$isDevelopment) console.log(this.L.Draw.Event.DRAWSTOP, data);
                    this.patchGeoitemEdit(data)
                });
                this.mapLeafletObject.on(this.L.Draw.Event.EDITMOVE, (e) => {
                    if(this.$isDevelopment) console.log(this.L.Draw.Event.EDITMOVE, e);
                    let data = {}
                    if (this.drawLayer) {
                        data = this.getDataFromLayer(this.drawLayer)
                    }
                    // if(this.$isDevelopment) console.log(this.L.Draw.Event.EDITMOVE, data);
                    this.patchGeoitemEdit(data)
                });
                this.mapLeafletObject.on(this.L.Draw.Event.EDITRESIZE, (e) => {
                    if(this.$isDevelopment) console.log(this.L.Draw.Event.EDITRESIZE, e);
                    let data = {}
                    if (this.drawLayer) {
                        data = this.getDataFromLayer(this.drawLayer)
                    }
                    // if(this.$isDevelopment) console.log(this.L.Draw.Event.EDITRESIZE, data);
                    this.patchGeoitemEdit(data)
                });
                this.mapLeafletObject.on(this.L.Draw.Event.EDITED, (e) => {//???
                    if(this.$isDevelopment) console.log(this.L.Draw.Event.EDITED, e);
                    var layers = e.layers;
                    var countOfEditedLayers = 0;
                    layers.eachLayer(function (/*layer*/) {
                        countOfEditedLayers++;
                    });
                    if(this.$isDevelopment) console.log("Edited " + countOfEditedLayers + " layers");
                });
            }

            {
                let geozone = this.createGeoiteme(newGeo)
                if (geozone) {
                    this.drawLayer = geozone;
                    this.drawLayer.editing.enable();
                    this.drawnItems.addLayer(geozone);
                    if (newGeo.type == 'polyline') {//draw temp polygone for polyline
                        if (this.drawLayer._latlngs) {
                            this.drawLayer.layerType = 'polyline';
                            this.DrawPolylineOnMap(this.drawLayer._latlngs);
                        }
                    }
                    setTimeout(() => {
                        let data = this.getDataFromLayer(this.drawLayer)
                        if (data) this.patchGeoitemEdit(data)
                    }, 100)
                } else {
                    switch (newGeo.type) {
                        case 'circle': {
                            this.draw = new this.L.Draw.Circle(this.mapLeafletObject, this.drawControl.options.draw.circle);
                        }
                            break;
                        case 'polygon': {
                            this.draw = new this.L.Draw.Polygon(this.mapLeafletObject, this.drawControl.options.draw.polygon);
                        }
                            break;
                        case 'corridor': {
                            this.draw = new this.L.Draw.Polyline(this.mapLeafletObject, this.drawControl.options.draw.polyline);
                        }
                            break;
                    }
                    this.draw.enable();
                }
            }
        },

        onReady() {
            this.geoitemEditLayer = this.$refs.geoitemEditLayer.leafletObject
        }
    },
    created() {
    },
    async beforeMount() {
        await import("leaflet-draw/dist/leaflet.draw.js");
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
        // if(this.$isDevelopment) console.log('Geoitems l-layer-group update')
    },
}
</script>

<style scoped>

</style>